import { memo } from "react";
import { Route, Navigate } from "react-router-dom";

import Login from "../pages/loginpages/signin";
import Forgot from "../pages/loginpages/forgot";
import Password from "../pages/loginpages/password";
import Otpverfication from "../pages/loginpages/otpverfication";

// import Dashboard from "../src/pages/dashboard";

import Protected from "./Protected";
import { isEmpty } from "../actions/common";
import NotFound from "../pages/NotFound";
export const PublicRoutes = (Auths, Token) => {
  const Auth = Auths && isEmpty(Token) ? true : false;
  const Auth_sign = Token && Auths ? false : true;
  return (
    <>
      <Route path="/" element={<Navigate to={"/signin"} replace />} />
      <Route
        path="/signin"
        element={
          <Protected isSignedIn={true}>
            <Login />
          </Protected>
        }
      />
      <Route
        path="/forgot"
        element={
          <Protected isSignedIn={true}>
            <Forgot />
          </Protected>
        }
      />
      <Route
        path="/Changepassword"
        element={
          <Protected isSignedIn={true}>
            <Password />
          </Protected>
        }
      />
      <Route
        path="/otpverfication"
        element={
          <Protected isSignedIn={true}>
            {" "}
            <Otpverfication />
          </Protected>
        }
      />
      <Route exact path="/notfound" element={<NotFound />} />
      {/* <Route exact path="/" element={<Login />}/>
        <Route path="/forgot" element={<Forgot />}/>
        <Route path="/password" element={<Password />}/>
        <Route path="/otpverfication" element={<Otpverfication />}/> */}
    </>
  );
};
